export class TreeSelectConfig {
    allClear?: boolean;
    placeHolder?: string;
    disabled?: boolean;
    multiple?: boolean;
    showSearch?: boolean;
    data?: any[];
    url?: string;
    params?: object;
    value?: string;
    constructor() {
        this.allClear = true;
        this.placeHolder = 'select data';
        this.disabled = false;
        this.multiple = false;
        this.showSearch = true;
        this.data = [];
        this.url = '';
        this.params = {};
        this.value = '';
    }
}
